import React, { useState, useEffect } from 'react'
import CustomTag from 'components/CustomTag'
import { COLORS } from 'theme'

const RoleStatus = ({ status }) => {
  const [statusData, setStatusData] = useState({
    color: 'green',
    background: COLORS.GREEN_T_92,
    message: 'Accepted',
    showCheck: true,
  })
  useEffect(() => {
    if (status == -1) {
      setStatusData({
        color: 'red',
        background: COLORS.RED_T_90,
        message: 'Rejected',
        showCheck: false,
      })
    }
  }, [status])
  return (
    <>
      {status != 0 ? (
        <CustomTag
          colorType={status == 1 ? 'green' : 'red'}
          background={statusData.background}
          message={status == 1 ? 'Accepted' : 'Rejected'}
          bordered={false}
          iconType={status == 1 ? 'check' : 'cross'}
          textWrap={'noWrap'}
          display={'flex'}
        />
      ) : (
        <CustomTag
          textWrap={'noWrap'}
          colorType={'orange'}
          background={statusData.background}
          message={'Pending'}
          bordered={false}
          iconType={'clock'}
          display={'flex'}
        />
      )}
    </>
  )
}

export default RoleStatus
